var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAcceos(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54,
    height: 62,
    viewBox: "0 0 54 62",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#9ABBB2",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.816 0H2.062C1.057 0 .242.807.242 1.803v57.945c0 .996.815 1.804 1.82 1.804h9.708c1.006 0 1.82-.808 1.82-1.804v-44.12h26.697v44.12c0 .996.815 1.804 1.82 1.804h9.709c1.005 0 1.82-.808 1.82-1.804V1.803C53.636.807 52.82 0 51.816 0zm-1.82 57.945h-6.068v-44.12c0-.996-.815-1.803-1.82-1.803H11.77c-1.005 0-1.82.807-1.82 1.803v44.12H3.883V3.607h46.112v54.338z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.871 30.537a6.552 6.552 0 0 0 1.742-4.45c0-3.646-2.994-6.612-6.674-6.612s-6.674 2.966-6.674 6.612c0 1.713.66 3.275 1.742 4.45-2.506 1.608-4.17 4.4-4.17 7.572v7.213c0 .996.816 1.804 1.821 1.804h1.82v12.622c0 .996.815 1.804 1.82 1.804h7.281c1.006 0 1.82-.808 1.82-1.804V47.126h1.82c1.006 0 1.821-.808 1.821-1.804V38.11c0-3.172-1.663-5.964-4.169-7.572zm-7.966-4.45c0-1.657 1.361-3.005 3.034-3.005 1.673 0 3.034 1.348 3.034 3.005 0 1.658-1.361 3.006-3.034 3.006-1.673 0-3.034-1.348-3.034-3.006zM32.4 43.52h-1.82c-1.006 0-1.82.807-1.82 1.803v12.623h-3.641V45.322c0-.996-.815-1.803-1.82-1.803h-1.82v-5.41c0-2.983 2.449-5.41 5.46-5.41 3.01 0 5.46 2.427 5.46 5.41v5.41z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAcceos);
export default __webpack_public_path__ + "static/media/acceos.bb8922e9318e87d5c45f8cc34301d965.svg";
export { ForwardRef as ReactComponent };